<div>
    <h2 style="margin-bottom: 5px;">{{'newOrder.trialLens.tabs.overRefraction.title' | translate}}</h2>
</div>

<div>
    <form [formGroup]="form">
                
        <div class="d-flex">
            <div class="d-flex over-refraction-parameter">
                <label [matTooltip]="'common.hints.Sphere' | translate" matTooltipPosition="above">{{"common.features.Sphere2" | translate}}<span class="span-label-required"></span>
                    <input formControlName="sphere" class="form-control parameter-input" (blur)="setValueWithFormat('Sphere', 'sphere')"
                    [ngClass]="{required: true, error: form.get('sphere').errors && (form.get('sphere').touched || (form.get('sphere').dirty))}"/>
                </label>
                <div class="info">
                    <img src="assets/img/icons/info.svg" [matTooltip]="'newOrder.finalLens.limits' | translate:getLimitsFormatted(-50,50)" matTooltipPosition="above">
                </div>
            </div>
 
            <div class="d-flex over-refraction-parameter">
                <label [matTooltip]="'common.hints.Cylinder' | translate" matTooltipPosition="above">{{"common.features.Cylinder" | translate}}<span class="span-label-required"></span>
                    <input formControlName="cylinder" class="form-control parameter-input" (blur)="setValueWithFormat('Cylinder', 'cylinder')"
                    [ngClass]="{required: true, error: form.get('cylinder').errors && (form.get('cylinder').touched || (form.get('cylinder').dirty))}"/>
                </label>
                <div class="info">
                    <img src="assets/img/icons/info.svg" [matTooltip]="'newOrder.finalLens.limits' | translate:getLimitsFormatted(-20,20)" matTooltipPosition="above">
                </div>
            </div>

            <div class="d-flex over-refraction-parameter" *ngIf="!isAxisDisable">
                <label [matTooltip]="'common.hints.Axis' | translate" matTooltipPosition="above">{{"common.features.Axis" | translate}}<span class="span-label-required"></span>
                    <input formControlName="axis" class="form-control parameter-input" (blur)="setValueWithFormat('Axis', 'axis')"
                    [ngClass]="{required: !isAxisDisable, error: !isAxisDisable && form.get('axis').errors && (form.get('axis').touched || (form.get('axis').dirty))}"/>
                </label>
                <div class="info">
                    <img src="assets/img/icons/info.svg" [matTooltip]="'newOrder.finalLens.limits' | translate:getLimitsFormatted(0,179)" matTooltipPosition="above">
                </div>
            </div>

            <div class="d-flex over-refraction-parameter" *ngIf="!isStabilizationDisable">
                <label [matTooltip]="'common.hints.Stabilization' | translate" matTooltipPosition="above">{{"common.features.Stabilization" | translate}}<span class="span-label-required"></span>
                    <input formControlName="stabilization" class="form-control parameter-input" (blur)="setValueWithFormat('Stabilization', 'stabilization')"
                    [ngClass]="{required: !isStabilizationDisable, error: !isStabilizationDisable && form.get('stabilization').errors && (form.get('stabilization').touched || (form.get('stabilization').dirty))}"/>
                </label>
                <div class="info">
                    <img src="assets/img/icons/info.svg" [matTooltip]="'newOrder.finalLens.limits' | translate:getLimitsFormatted(0,179)" matTooltipPosition="above">
                </div>
            </div>

            <div class="d-flex over-refraction-parameter" *ngIf="!isHSADisable">
                <label [matTooltip]="'common.hints.HSA' | translate" matTooltipPosition="above">{{"common.features.HSA" | translate}}<span class="span-label-required"></span>
                    <input formControlName="hsa" class="form-control parameter-input" (blur)="setValueWithFormat('HSA', 'hsa')"
                    [ngClass]="{required: !isHSADisable, error: !isHSADisable && form.get('hsa').errors && (form.get('hsa').touched || (form.get('hsa').dirty))}"/>
                </label>
                <div class="info">
                    <img src="assets/img/icons/info.svg" [matTooltip]="'newOrder.finalLens.limits' | translate:getLimitsFormatted(5,35)" matTooltipPosition="above">
                </div>
            </div>
        </div>
    </form>

    <app-validation-error [form]="form"></app-validation-error>
</div>